const cityBodyClasses = new Map([
  ["/lodz", "park-lodz"],
  ["/szczecin", "park-szczecin"],
  ["/krakow", "park-krakow"],
  ["/zakopane", "park-zakopane"],
]);

const PAGE_BODY_CLASSES = [...cityBodyClasses.values()];

const PAGE_BODY_CLASSES_BY_PATH = Object.fromEntries(
  [...cityBodyClasses].flatMap(([pathname, bodyClass]) => [
    [pathname, bodyClass],
    [`${pathname}/`, bodyClass],
  ]),
);

const getPageBodyClass = (pathname) =>
  Object.hasOwn(PAGE_BODY_CLASSES_BY_PATH, pathname)
    ? PAGE_BODY_CLASSES_BY_PATH[pathname]
    : null;

module.exports = {
  PAGE_BODY_CLASSES,
  PAGE_BODY_CLASSES_BY_PATH,
  getPageBodyClass,
};
